import { Notification } from '@bringg/react-components';

export default Notification;
